export interface Project {
  id: number;
  title: string;
  description: string;
  link: string;
}

export const projectData: Project[] = [  
  {
    id: 1,
    title: "Java Text Editor",
    description: "",
    link: "https://github.com/TheShanachie/TextEditor"
  },

  {
    id: 2,
    title: "General Sudoku Solver",
    description: "",
    link: "https://github.com/TheShanachie/sudoku-solver"
  },

  {
    id: 3,
    title: "Linear Algebra Utilities",
    description: "",
    link: "https://github.com/TheShanachie/linear-algebra-utils"
  },

  {
    id: 4,
    title: "Tafl-Game Engine and Utilities",
    description: "",
    link: "https://github.com/TheShanachie/tafl-game-engine"
  },

  {
    id: 5,
    title: "Updating Moscow SML Implementation of Uscheme Interpreter",
    description: "",
    link: "https://github.com/TheShanachie/editing-mosml-uscheme-interpreter"
  },

  {
    id: 6,
    title: "Custom Unix Shell",
    description: "",
    link: "https://github.com/TheShanachie/custom-unix-shell"
  },

  {
    id: 7,
    title: "Property Record Web Scraping",
    description: "",
    link: "https://github.com/TheShanachie/property-record-web-scraping"
  },

  {
    id: 8,
    title: "Personal Portfolio Website",
    description: "",
    link: "https://github.com/TheShanachie/portfolio-website"
  },

  {
    id: 9,
    title: "Retro-Chip React Component",
    description: "",
    link: 'https://github.com/TheShanachie/tech-logo-animation'

  },

  {
    id: 10,
    title: "Discord Bot for LeetCode Challenges",
    description: "",
    link: 'https://github.com/TheShanachie/leetcode-discord-bot'

  },


]; 